import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {PaymentTypeBO} from "./PaymentTypeBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class PaymentTypeBOAudit {


    static async PaymentTypeAuditBO(PaymentTypeBO: PaymentTypeBO): Promise<AuditService> {
        const self = PaymentTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("PaymentType", self.drWB_PmtType.cif.WB_PMTTYPE_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const tpmPaymentParams: IAuditField [] = [
            {fieldName: "PAYMENT_TYPE_ID",              realName: "ID"}, //create
            {fieldName: "PAYMENT_TYPE_NAME",                realName: "Name" }, //create
            {fieldName: "PAYMENT_TYPE_COMMENTS",  realName: "Description"},
            {fieldName: "TREE_PATH",        realName: "Tree Path"},
            {fieldName: "WB_BUSINESSUNIT_ID",          realName: "Business Unit"},
            {fieldName: "SOURCE_ID",         realName: "Source"},
            {fieldName: "MANUAL_IND",       realName: "Manual"},
            {fieldName: "ACTIVE_IND",         realName: "Active"},
            {fieldName: "WORKFLOW_POLICY",              realName: "Workflow Policy", bAllMsg: true }, //create
            {fieldName: "WB_WORKFLOW_ID",                realName: "Workflow ID",  bAllMsg: true }, //create
            {fieldName: "CREATE_POLICY",  realName: "Create Policy"},

            {fieldName: "PLANNING_CUST_SHOW_IND",        realName: "Show Planning Customer"},
            {fieldName: "FUNDING_CUST_SHOW_IND",          realName: "Show Funding Customer"},
            {fieldName: "PAYTO_CUST_SHOW_IND",         realName: "Show PayTo Customer"},
            {fieldName: "EXPENSETO_CUST_SHOW_IND",       realName: "Show ExpenseTo Customer"},
            {fieldName: "CURRENCY_POLICY",         realName: "Currency Policy"},
            {fieldName: "CURRENCY_DEFAULT",              realName: "Default Currency"}, //create
            {fieldName: "CURRENCY_OPTIONS",                realName: "Currency Options"}, //create
            {fieldName: "CLAIM_POLICY",  realName: "Claim Policy",},
            {fieldName: "EVENT_SPEND_POLICY",        realName: "Event Funding Policy"},
            {fieldName: "FUND_SPEND_POLICY",          realName: "Direct Fund Policy"},
            {fieldName: "SHOW_CORRECTION_IND",         realName: "Show Correction UI"},
            {fieldName: "SHOW_CHECK_IND",       realName: "Show Check UI"},
            {fieldName: "SHOW_CREDIT_MEMO_IND",         realName: "Show Credit Memo UI"},
            {fieldName: "SHOW_OFF_INVOICE_IND",              realName: "Show Invoice Details"}, //create
            {fieldName: "NEGATIVE_PAYMENT_IND",                realName: "Negative"}, //create

        ]

        // ClaimType PaymentType Rows
        const tpmClaimTypePaymentTypeParams: IAuditField [] = [
            {fieldName: "CLAIM_TYPE_ID",          realName: "Claim Type ID", },
            {fieldName: "CLAIM_TYPE_NAME",    realName: "Claim Type Name", },
            {fieldName: "DEFAULT_IND",  realName: "Default", },

        ]





        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_PaymentType, tpmPaymentParams, {objectName: 'PaymentType', deletedKeys: deleteKeys})

        // ClaimType PaymentType Rows
        for(let aClaimTypePaymentTypeRow of self.drWB_PmtType.WB_ClaimTypePaymentTypeRows) {
            await AuditUtils.logRecord(auditService, aClaimTypePaymentTypeRow, tpmClaimTypePaymentTypeParams,{objectName: 'ClaimType PaymentType', deletedKeys: deleteKeys})
        }






        return auditService
    }



}
